module.exports = __webpack_public_path__ + "img/img-area-auditoria-banner.0d8c0741.png";